import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import TimeoutUtility from "../../contexts/TimeoutUtility";
import { validateField } from "../../contexts/Utils";
import {
  GetAllEmployees,
  getInvPartsByFilter,
  getGPUbySn,
  getWBbySn,
  CreateAssemblyApi,
} from "../../api";
import { Header, Button } from "../../components";
import "../../styles/AddPart.css";
import { Container, Col, Row } from "react-bootstrap";
import { useStateContext } from "../../contexts/ContextProvider";
import TextAreaField from "../../components/TextAreaField";
import TextInputField from "../../components/TextInputField";
import SelectField from "../../components/SelectField";
import { showSuccessToast, showErrorToast } from "../../components/ToastMesg";
import DateTimeField from "../../components/DateTimeField";
import DateInputField from "../../components/DateInputField";

const CreateAssembly = () => {
  const navigate = useNavigate();
  let param = useParams();
  const so_id = param.so_id;
  const gpuRef = useRef(null);
  const { storeG, userID } = useStateContext();
  const [getParts, setParts] = useState([]);
  const [getEmployees, setEmployees] = useState([]);
  const [gpuSn, setGpuSn] = useState("");
  const [wbScan, setWbScan] = useState("");
  const [formData, setFormData] = useState({
    part: "Select Part",
    gpu_id: 0,
    gpu_sn: "",
    gpu_part: "",
    gpu_name: "",
    specs: "",
    sku: "",
    box_id: "",
    lot_no: "",
    recv_date: "",
    test_date: "",
    test: "",
    wb_id: 0,
    wb_scan: "",
    wb_sn: "",
    wb_part: "",
    wb_name: "",
    wb_specs: "",
    wb_id_no1: "",
    wb_id_no2: "",
    wb_recv_date: "",
    wb_prod_date: "",
    employee: "Select Employee",
    check1: false,
    check2: false,
    check3: false,
    check4: false,
    other: "",
    note: "",
  });
  const [oDatetime, setODatetime] = useState("");
  const [errors, setErrors] = useState({});
  const [loadBtn, setLoadBtn] = useState(false);

  const handleBackClick = () => {
    TimeoutUtility.resetTimeout();
    navigate("/GpuWb");
  };

  const handleChange = async (e) => {
    const { name, value } = e.target;
    if (name === "gpu_sn") {
      setGpuSn(value);
      if (value.length > 10 && value.length < 18) {
        await getGPUbySn(value)
          .then((resp) => {
            if (
              resp?.data &&
              !resp?.data?.pull_scan_date &&
              resp?.data?.so_id &&
              resp?.data?.status_id === 12
            ) {
              setFormData((prev) => ({
                ...prev,
                gpu_id: resp.data.gpu_id,
                so_id: resp.data.so_id,
                gpu_sn: resp.data.gpu_sn,
                gpu_part: `${resp.data.part_number} - ${resp.data.part_description}`,
                gpu_name: resp.data.name,
                specs: resp.data.specs,
                sku: resp.data.sku,
                box_id: resp.data.box_id,
                lot_no: resp.data.lot_no,
                recv_date: resp.data.recv_scan_date.slice(0, -1),
                test_date: resp.data.test_scan_date.slice(0, -1),
                test: resp.data.test_result,
              }));
              var now = new Date();
              now.setMinutes(now.getMinutes() - now.getTimezoneOffset());
              setODatetime(now.toISOString().slice(0, 19));
            } else
              setFormData((prev) => ({ ...prev, [name]: value, gpu_id: 0 }));
          })
          .catch((err) => console.log(err.message));
      } else setFormData((prev) => ({ ...prev, [name]: value, gpu_id: 0 }));
    } else if (name === "wb_scan") {
      setWbScan(value);
      if (value.length > 74) {
        const strings = value.split(">");
        if (strings.length === 4) {
          const snin = strings[1].indexOf("R") || "";
          if (snin !== -1) {
            const wb_snnn = strings[1].slice(snin);
            await getWBbySn(wb_snnn)
              .then((resp) => {
                if (resp?.data && !resp?.data?.pull_scan_date) {
                  setFormData((prev) => ({
                    ...prev,
                    wb_id: resp.data.wb_id,
                    wb_scan: value,
                    wb_sn: resp.data.sn,
                    wb_part: `${resp.data.part_number} - ${resp.data.part_description}`,
                    wb_name: resp.data.name,
                    wb_specs: resp.data.specs,
                    wb_id_no1: resp.data.id_no1,
                    wb_id_no2: resp.data.id_no2,
                    wb_recv_date: resp.data.recv_scan_date.slice(0, -1),
                    wb_prod_date: resp.data.prod_date.split("T")[0],
                  }));
                  var now = new Date();
                  now.setMinutes(now.getMinutes() - now.getTimezoneOffset());
                  setODatetime(now.toISOString().slice(0, 19));
                } else
                  setFormData((prev) => ({ ...prev, [name]: value, wb_id: 0 }));
              })
              .catch((err) => console.log(err.message));
          } else setFormData((prev) => ({ ...prev, [name]: value, wb_id: 0 }));
        } else setFormData((prev) => ({ ...prev, [name]: value, wb_id: 0 }));
      } else setFormData((prev) => ({ ...prev, [name]: value, wb_id: 0 }));
    } else setFormData((prev) => ({ ...prev, [name]: value }));

    const error = validateField(name, value, name);
    setErrors((prev) => ({ ...prev, [name]: error }));
  };

  const handleSelectChange = (option, e) => {
    if (option && option.value) {
      setFormData((prev) => ({ ...prev, [e.name]: option }));
      const error = validateField(e.name, option, e.name);
      setErrors((prev) => ({ ...prev, [e.name]: error }));
    } else setFormData((prev) => ({ ...prev, [e.name]: "select" }));
  };

  const handleCheckChange = (e) => {
    const name = e.target.name;
    setFormData((prev) => ({ ...prev, [name]: !formData[name] }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    TimeoutUtility.resetTimeout();
    setLoadBtn(true);
    const newErrors = {};
    Object.keys(formData).forEach((key) => {
      const error = validateField(key, formData[key], key);
      if (error) newErrors[key] = error;
    });
    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) {
      setLoadBtn(false);
      return;
    }
    if (!formData.gpu_id) {
      showErrorToast(
        "Error!",
        "GPU not found!\nKindly rescan the correct GPU.",
      );
      setLoadBtn(false);
      gpuRef?.current?.focus();
      return;
    }
    if (!formData.wb_id) {
      showErrorToast(
        "Error!",
        "Water Block not found!\nKindly rescan the correct Water Block.",
      );
      setLoadBtn(false);
      return;
    }
    if (
      !formData.check1 ||
      !formData.check2 ||
      !formData.check3 ||
      !formData.check4
    ) {
      showErrorToast("Error!", "Kindly perform all the Assembly steps!");
      setLoadBtn(false);
      return;
    }
    const reqData = {
      gpu_id: formData.gpu_id,
      wb_id: formData.wb_id,
      part_id: formData.part.value,
      store_id: storeG.store_id,
      employee_id: formData.employee.value,
      user_id: userID,
      so_id: formData.so_id,
      name: formData.gpu_name,
      specs: formData.specs,
      detail: formData.detail,
      install_date: oDatetime,
      box_qrcode: "",
      master_qrcode: `${formData.gpu_sn}>${formData.wb_sn}`,
      master_sn: `${formData.gpu_sn}>${formData.wb_sn}`,
      box_id: "",
      assembler: "",
      lot_no: "",
      other: formData.other,
      notes: formData.note,
    };
    try {
      const response = await CreateAssemblyApi(reqData);
      if (response.success) {
        showSuccessToast("Success!", "Assembly created successfully!");
        setFormData((prev) => ({
          ...prev,
          gpu_id: 0,
          gpu_sn: "",
          gpu_part: "",
          gpu_name: "",
          specs: "",
          sku: "",
          box_id: "",
          lot_no: "",
          recv_date: "",
          test_date: "",
          test: "",
          wb_id: 0,
          wb_scan: "",
          wb_sn: "",
          wb_part: "",
          wb_name: "",
          wb_specs: "",
          wb_id_no1: "",
          wb_id_no2: "",
          wb_recv_date: "",
          wb_prod_date: "",
          other: "",
          note: "",
        }));
        setGpuSn("");
        setWbScan("");
        gpuRef?.current?.focus();
      } else
        showErrorToast("Error!", "Assy failed to add!\n\n" + response.message);
    } catch (err) {
      showErrorToast("Error!", "Assembly did not create!");
    } finally {
      setLoadBtn(false);
    }
  };

  useEffect(() => {
    async function fetchData() {
      if (storeG?.store_id) {
        TimeoutUtility.resetTimeout();
        await GetAllEmployees()
          .then((resp) => {
            const employeeOptions = resp.data.map((item) => ({
              label: item.name,
              value: item.employee_id,
            }));
            setEmployees(employeeOptions || []);
          })
          .catch((err) => console.log(err.message));
        await getInvPartsByFilter(storeG?.store_id, null, 136)
          .then((resp) => {
            const partOptions = resp.data.map((item) => ({
              label: item.part_number + " - " + item.description,
              value: item.part_id,
            }));
            setParts(partOptions || []);
          })
          .catch((err) => console.log(err.message));
      }
    }
    fetchData();
  }, [storeG]);

  return (
    <div className="m-0 md:m-4 p-4 md:p-8 main-div-bg">
      <Header title="ASSEMBLE GPUs" />
      <form>
        <Container className="g-0 form-container" fluid="true">
          <Row xs={1} sm={1} className="p-0 justify-content-center">
            <Col xl={10} lg={12} className="container-col">
              <SelectField
                label="Assembly Part:"
                name="part"
                value={formData.part}
                options={getParts}
                onChange={handleSelectChange}
                placeholder="Assembly Part"
                compulsory={true}
                error={errors.part}
                autoFocus
              />
            </Col>
          </Row>
          <Row xs={1} sm={1} className="p-0 justify-content-center">
            <Col xl={4} lg={4} className="container-col">
              <TextInputField
                ref={gpuRef}
                label="GPU SN Scan:"
                name="gpu_sn"
                value={gpuSn}
                onChange={handleChange}
                placeholder="GPU SN"
                compulsory={true}
              />
            </Col>
            <Col xl={8} lg={8} className="container-col">
              <TextInputField
                label="GPU Block Scan:"
                name="wb_scan"
                value={wbScan}
                onChange={handleChange}
                placeholder="GPU Block Scan"
                compulsory={true}
              />
            </Col>
          </Row>
          <Row xs={1} sm={1} className="p-0 justify-content-center">
            <Col xl={4} lg={4} className="container-col">
              <TextInputField
                label="SO:"
                name="so_id"
                value={so_id}
                placeholder="Name"
                disabled
              />
            </Col>
            <Col xl={8} lg={8} className="container-col"></Col>
          </Row>
          <Row xs={1} sm={1} className="p-0 justify-content-center">
            <Col xl={4} lg={4} className="container-col">
              <div className="col-lg-12">
                <TextInputField
                  label="GPU Part:"
                  name="gpu_part"
                  value={formData.gpu_part}
                  placeholder="GPU Part"
                  disabled
                />
                <TextInputField
                  label="Name:"
                  name="gpu_name"
                  value={formData.gpu_name}
                  placeholder="Name"
                  disabled
                />
                <TextInputField
                  label="Specs:"
                  name="specs"
                  value={formData.specs}
                  placeholder="Specs"
                  disabled
                />
                <TextInputField
                  label="SKU:"
                  name="sku"
                  value={formData.sku}
                  placeholder="SKU"
                  disabled
                />
                <TextInputField
                  label="Box ID:"
                  name="box_id"
                  value={formData.box_id}
                  placeholder="Box ID"
                  disabled
                />
                <TextInputField
                  label="Lot #:"
                  name="lot_no"
                  value={formData.lot_no}
                  placeholder="Lot #"
                  disabled
                />
                <DateTimeField
                  label="Recv Datetime:"
                  name="recv_date"
                  value={formData.recv_date}
                  placeholder="DateTime"
                  now={false}
                  formField={true}
                  disabled
                />
                <DateTimeField
                  label="Last Test Datetime:"
                  name="test_date"
                  value={formData.test_date}
                  placeholder="DateTime"
                  now={false}
                  formField={true}
                  disabled
                />
                <TextInputField
                  label="Last Test Result:"
                  name="test"
                  value={formData.test}
                  placeholder="Test Result"
                  disabled
                />
              </div>
            </Col>
            <Col xl={4} lg={4} className="container-col">
              <div className="col-lg-12">
                <TextInputField
                  label="GPU Block Part:"
                  name="wb_part"
                  value={formData.wb_part}
                  placeholder="GPU Block Part"
                  disabled
                />
                <TextInputField
                  label="Name:"
                  name="wb_name"
                  value={formData.wb_name}
                  placeholder="Name"
                  disabled
                />
                <TextInputField
                  label="Specs:"
                  name="wb_specs"
                  value={formData.wb_specs}
                  placeholder="Specs"
                  disabled
                />
                <TextInputField
                  label="SN:"
                  name="wb_sn"
                  value={formData.wb_sn}
                  placeholder="SN"
                  disabled
                />
                <TextInputField
                  label="ZOOX ID No:"
                  name="wb_id_no1"
                  value={formData.wb_id_no1}
                  placeholder="ZOOX ID No"
                  disabled
                />
                <TextInputField
                  label="PNY ID No:"
                  name="wb_id_no2"
                  value={formData.wb_id_no2}
                  placeholder="PNY ID No"
                  disabled
                />
                <DateTimeField
                  label="Recv Datetime:"
                  name="wb_recv_date"
                  value={formData.wb_recv_date}
                  placeholder="DateTime"
                  now={false}
                  formField={true}
                  disabled
                />
                <DateInputField
                  label="Prod Date:"
                  name="wb_prod_date"
                  value={formData.wb_prod_date}
                  placeholder="DateTime"
                  disabled
                />
              </div>
            </Col>
            <Col xl={4} lg={4} className="container-col">
              <DateTimeField
                label="Assembly Datetime:"
                name="assm_date"
                value={oDatetime}
                placeholder="DateTime"
                now={false}
                formField={true}
                disabled
              />
              <SelectField
                label="Assembly Operator:"
                name="employee"
                value={formData.employee}
                options={getEmployees}
                onChange={handleSelectChange}
                placeholder="Operator"
                compulsory={true}
                error={errors.employee}
                isDisabled={!formData.gpu_id || !formData.wb_id}
              />
              <label className="label mt-3">Assembly Steps:</label>
              <label className="text-md flex mt-2">
                <input
                  type="checkbox"
                  name="check1"
                  onChange={handleCheckChange}
                  style={{ marginRight: "4px" }}
                  checked={formData.check1}
                  disabled={!formData.gpu_id || !formData.wb_id}
                />
                Apply Filler and Grease
              </label>
              <label className="text-md flex mt-1">
                <input
                  type="checkbox"
                  name="check2"
                  onChange={handleCheckChange}
                  style={{ marginRight: "4px" }}
                  checked={formData.check2}
                  disabled={!formData.gpu_id || !formData.wb_id}
                />
                Place GPU on to Block and screw to necessary Torque
              </label>
              <label className="text-md flex mt-1">
                <input
                  type="checkbox"
                  name="check3"
                  onChange={handleCheckChange}
                  style={{ marginRight: "4px" }}
                  checked={formData.check3}
                  disabled={!formData.gpu_id || !formData.wb_id}
                />
                Run GPU on Ever 10th GPU
              </label>
              <label className="text-md flex mt-1">
                <input
                  type="checkbox"
                  name="check4"
                  onChange={handleCheckChange}
                  style={{ marginRight: "4px" }}
                  checked={formData.check4}
                  disabled={!formData.gpu_id || !formData.wb_id}
                />
                Successful Process
              </label>
              {/* <TextInputField
                label="Remarks:"
                name="comment"
                value={formData.comment}
                onChange={handleChange}
                placeholder="Remarks"
                error={errors.comment}
                disabled={!formData.gpu_id || !formData.wb_id}
              /> */}
              <TextInputField
                label="Other:"
                name="other"
                value={formData.other}
                onChange={handleChange}
                placeholder="Other"
                error={errors.other}
                disabled={!formData.gpu_id || !formData.wb_id}
              />
              <TextAreaField
                label="Note:"
                name="note"
                value={formData.note}
                onChange={handleChange}
                placeholder="Note"
                error={errors.note}
                disabled={!formData.gpu_id || !formData.wb_id}
              />
              <Row md={"auto"} className="justify-content-center pt-4">
                <Button
                  margin="10px"
                  padding="20px"
                  text="Create & Next"
                  onClick={handleSubmit}
                  disabled={loadBtn}
                />
                <Button
                  margin="10px"
                  padding="20px"
                  text="Close"
                  onClick={handleBackClick}
                />
              </Row>
            </Col>
          </Row>
        </Container>
      </form>
    </div>
  );
};

export default CreateAssembly;
